export default __webpack_public_path__ + "static/ens-background-fd201044ddb49ea2e534e365e36342aa.jpeg";